
import LoanApplication from "../../../models/loan/loanApplication";
import PagedList from "../../../models/accessors/pagedList";
import { LoanApplicationActionTypes, LoanApplicationState, PAGED_LOAN_APPLICATIONS, LOAN_APPLICATION_DETAILS, LOAN_ADD_DOCUMENT, LOAN_DELETE_DOCUMENT, LOAN_OPENREQUESTS, ID_DOCUMENTS_UPLOADED } from "../../store/loan/types";
import DocumentRequest from "models/documentData/DocumentRequest";

const initialState: LoanApplicationState = {
    pagedLoanApplications: {} as PagedList<LoanApplication>,
    loanApplicationDetails: {} as LoanApplication,
    openDocumentRequests: [] as DocumentRequest[],
};

export default function loans(
    state = initialState,
    action?: LoanApplicationActionTypes
): LoanApplicationState {
    switch (action?.type) {
        case PAGED_LOAN_APPLICATIONS: {
            return {
                ...state,
                pagedLoanApplications: action.payload.pagedLoanApplications
            };
        }

        case LOAN_APPLICATION_DETAILS: {
            return {
                ...state,
                loanApplicationDetails: action.payload.loanApplicationDetails
            };
        }

        case LOAN_ADD_DOCUMENT: {
            return {
                ...state,
                loanApplicationDetails: {
                    ...state.loanApplicationDetails,
                    customerAccount: {
                        ...state.loanApplicationDetails.customerAccount,
                        loanDocuments: state.loanApplicationDetails.customerAccount.loanDocuments?.concat(action.payload.loanDocuments)
                    }
                }
            };
        }        

        case LOAN_DELETE_DOCUMENT: {
            return {
                ...state,
                loanApplicationDetails: {
                    ...state.loanApplicationDetails,
                    customerAccount: {
                        ...state.loanApplicationDetails.customerAccount,
                        loanDocuments: [...(state.loanApplicationDetails.customerAccount.loanDocuments ?? []).filter(ln => ln.id !== action.payload.loanDocumentId)]
                    }
                }
            };
        }

        case LOAN_OPENREQUESTS: {
            return {
                ...state,
                openDocumentRequests: action.payload.openDocumentRequests
            };
        }

        case ID_DOCUMENTS_UPLOADED: {
            return {
                ...state,
                loanApplicationDetails: {
                    ...state.loanApplicationDetails,
                    customerAccount: {
                        ...state.loanApplicationDetails.customerAccount,
                        customerAccountVerificationDocuments: [action.payload.customerDocuments]
                    }
                }
            };
        }    
        
        default:
            return state;
    }
}
